import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';

import './ml';
import store from './store';


Vue.use(VueRouter);

Vue.config.productionTip = false;

const router = new VueRouter({mode: 'history', routes});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.checkIfVoted)) {
        if (!router.app.$store.state.voted) {
            next()
        } else {
            router.push(from.path);
        }
    } else {
        next()
    }
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
